import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { Trans } from '@lingui/macro'
import {
  Badge
  , Box
  , Breadcrumbs
  , Button
  , Card
  , CircularProgress
  , Dialog
  , DialogActions
  , DialogContent
  , DialogContentText
  , DialogTitle
  , Drawer
  , IconButton
  , Link
  , styled
  , Typography
  , useTheme
} from '@mui/material'
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import SaveIcon from '@mui/icons-material/Save'
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar'
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined'
import PersonIcon from '@mui/icons-material/Person'
import PersonOutlinedIcon from '@mui/icons-material/PersonOutline'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import EditRoadSharpIcon from '@mui/icons-material/EditRoadSharp'
import DeleteIcon from '@mui/icons-material/Delete'
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown'
// import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined'
// import SaveAsOutlinedIcon from '@mui/icons-material/SaveAsOutlined'
// import InfoIcon from '@mui/icons-material/Info'
// import EditRoadIcon from '@mui/icons-material/EditRoad'
// import TrafficOutlinedIcon from '@mui/icons-material/TrafficOutlined'
import Form from './Form'
import useOnlineStatus from '../../hooks/useOnlineStatus'
import SvgCustomIcon from "../icons/SvgCustomIcon";

const AddIcon = ({ variant }) => (
  <>
    {variant === 'person' && <SvgCustomIcon color={'white'} name={'person'} />}
    {variant === 'unit' && <SvgCustomIcon color={'white'} name={'car'} />}
    <Typography variant='h6' fontWeight={700}>+</Typography>
  </>
)

export default function FormContainer ({
  token
  , open
  , isLoading
  , isMobile
  , formModel
  , formList
  , form
  , submitRef
  , handleFormOpen
  , handleSetFormNumber
  , handleCrashSubmit
  , handleAppend
  , handleRemove
  , images
  , reporterData
  , cancelCrash
}) {
  const location = useLocation()
  const { init } = location.state
  const { control, setValue, formState, getValues, user } = useFormContext()
  const [crashId, setCrashId] = useState('')
  const [roadBadge, setRoadBadge] = useState(false)
  const [unitsBadge, setUnitsBadge] = useState(0)
  const [peopleBadge, setPeopleBadge] = useState(0)
  const [isSaveDialogOpen, setIsSaveDialogOpen] = useState(false)
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false)
  const [unitFormList, setUnitFormList] = useState([])
  const [lastUnitFormIndex, setlastUnitFormIndex] = useState(0)
  const [peopleFormList, setPeopleFormList] = useState([])
  const [lastPeopleFormIndex, setlastPeopleFormIndex] = useState(0)
  const [isReadOnly, setIsReadOnly] = useState(false)
  const [isNew, setIsNew] = useState(false)
  const theme = useTheme()
  const isOnline = useOnlineStatus()

  const memoizedFormModel = React.useMemo(() => formModel, [formModel]);
  const memoizedFormList = React.useMemo(() => formList, [formList]);
  const memoizedForm= React.useMemo(() => form, [form]);

  console.log('F CONT', formList, form, formModel, init.user, user)

  useEffect(() => {
    // create a list of units forms
    const unitFormList = formList.filter(form => /^units\.\d+$/.test(form))
    if (unitFormList?.length) setUnitFormList(unitFormList)
    const currentUnitFormListIndex = unitFormList?.indexOf(form.name)
    if (currentUnitFormListIndex !== -1) setlastUnitFormIndex(currentUnitFormListIndex)
    // create a list of people
    const peopleFormList = formList.filter(form => /^(units\.\d+\.)people\.\d+$/.test(form))
    if (peopleFormList?.length) setPeopleFormList(peopleFormList)
    const currentPeopleFormListIndex = peopleFormList?.indexOf(form.name)
    if (currentPeopleFormListIndex !== -1) setlastPeopleFormIndex(currentPeopleFormListIndex)
  }, [formList, form.name])

  const { append, remove } = useFieldArray({
    control
    , name: form.type === 'units' || form.type === 'people'
      ? `${(formList[form.number] || []).split('.').slice(0, 2).join('.')}.people`
      : form.type
  })

  const openSaveDialog = () => { setIsSaveDialogOpen(true) }

  const closeSaveDialog = () => { setIsSaveDialogOpen(false) }

  const openDeleteDialog = () => { setIsDeleteDialogOpen(true) }

  const closeDeleteDialog = () => { setIsDeleteDialogOpen(false) }

  const getFormCtxUserOrg = () => {
    if (init.user.type === 1 && Object.prototype.hasOwnProperty.call(user, 'doAsOrganization')) {
      return user.doAsOrganization
    }
    return init.user.organization
  }

  // children = Children.map(children, el => cloneElement(el, { submitRef, handleSubmit }))

  useEffect(() => {
    console.log('FORM STATE', formState)
    console.log('FORM VALUES', getValues())
    const form = getValues()
    setCrashId(form.crash['Crash id'])
    setIsNew(form.isNew)
    if (Object.prototype.hasOwnProperty.call(form, 'units')) {
      setUnitsBadge(form.units.length)
      setRoadBadge(true)
      setPeopleBadge(form.units.map(unit => unit.people?.length).reduce((a, c) => a + c, 0))
    }
    if (Object.prototype.hasOwnProperty.call(form, 'people') && form?.people?.length) {
      setPeopleBadge(form.people.length)
    }
  }, [formState, getValues])

  useEffect(() => {
    setIsReadOnly(!!getValues('crash.merge_date'))
  }, [crashId, getValues])

  let StyledDrawer
  if (isMobile) {
    StyledDrawer = styled(Drawer)(({ theme }) => ({
      '& .MuiDrawer-paper': {
        height   : `calc(100dvh - ${theme.mixins.toolbar.minHeight}px)`
        , width  : '100dvw'
      }
    }))
  } else {
    StyledDrawer = styled(Drawer)(({ theme }) => ({
      position               : 'relative' // imp
      , width                : theme.mixins.formDrawerWidth
      , '& .MuiDrawer-paper' : {
        width        : theme.mixins.formDrawerWidth
        , height     : `calc(100vh - ${theme.mixins.toolbar.minHeight}px)`
        , position   : 'absolute' // imp
        , transition : 'none !important'
      }
    }))
  }

  return (
    <StyledDrawer
      variant="persistent"
      open={open}
      anchor={isMobile ? 'bottom' : undefined}

    >
      {isMobile && <Box sx={{ textAlign: 'center', pt: 1 }}>
        <IconButton onClick={() => handleFormOpen(false)}>
          <KeyboardDoubleArrowDownIcon />
        </IconButton>
      </Box>}
      <Box display='flex' flexDirection='column' p={1} pb={1.5}>
        <Typography width='100%' variant='button' sx={{color: theme.palette.newColors.gray}} fontWeight={700} textAlign='center'>
          {isNew ? <Trans> ADD NEW CRASH RECORD</Trans> : <Trans>CRASH RECORD</Trans>}
        </Typography>
        <Typography textTransform='uppercase' sx={{color: theme.palette.newColors.gray}} width='100%' variant='h6' fontWeight={600} textAlign='center'>
          {`${form.displayName}${form.type === 'units' ? ' ' + (lastUnitFormIndex + 1) : form.type === 'people' ? ' ' + (lastPeopleFormIndex + 1) : ''}`}
        </Typography>
        {isMobile &&
          <Breadcrumbs sx={{ alignSelf: 'center' }} aria-label="breadcrumb">
            {form.name !== 'crash' && <Link
              component="button"
              onClick={() => {
                handleSetFormNumber(formList.indexOf('crash'))
              }}
            >
              Crash
            </Link>}
            {formList.includes('road') && form.name === 'road' &&
              <Link
                component="button"
                onClick={() => {
                  handleSetFormNumber(formList.indexOf('road'))
                }}
              >
                Road
              </Link>
            }
            {form.name.match(/\w+\.\d+/g)?.map(match =>
              <Link
                component="button"
                onClick={() => {
                  handleSetFormNumber(formList.indexOf(match))
                }}
              >
                {match.split('.').map(m => {
                  if (!isNaN(Number.parseInt(m))) return Number.parseInt(m) + 1
                  return m
                    .replace('units', 'Unit')
                    .replace('people', 'Person')
                }).join(' ')
                }
              </Link>
            )}
          </Breadcrumbs>
        }
        <Box mt={1} display='flex' justifyContent='space-evenly' alignItems='center' width='100%'>
          <Badge
            color='success'
            overlap='circular'
            variant='dot'
            invisible={formState.submitCount === 0}
          >
            <IconButton
              sx={form.type === 'crash' ? { backgroundColor: theme.palette.newColors.gray } : {}}
              onClick={() => {
                if (form.type !== 'crash') {
                  submitRef.current.requestSubmit()
                  handleSetFormNumber(formList.indexOf('crash'))
                }
              }}
            >
              <SvgCustomIcon name={'info'} color={form.type === 'crash' ? 'white' : theme.palette.newColors.gray} />
            </IconButton>
          </Badge>
          {Object.prototype.hasOwnProperty.call(formModel, 'road') &&
            <Badge
            color='success'
            overlap='circular'
            variant='dot'
            invisible={!roadBadge}
          >
              <IconButton
                sx={form.type === 'road' ? { backgroundColor: theme.palette.newColors.gray  } : {}}
                onClick={() => {
                  if (form.type !== 'road') {
                    submitRef.current.requestSubmit()
                    handleSetFormNumber(formList.indexOf('road'))
                  }
                }}
              >
                <SvgCustomIcon name={'road'} color={form.type === 'road' ? 'white' : theme.palette.newColors.gray} />
            </IconButton>
          </Badge>}
          {Object.prototype.hasOwnProperty.call(formModel, 'units') &&
            <Badge
              color='primary'
              overlap='circular'
              badgeContent={unitsBadge}
            >
              <IconButton
                sx={form.type === 'units' ? { backgroundColor: theme.palette.newColors.gray } : {}}
                onClick={() => {
                  submitRef.current.requestSubmit()
                  let nextUnitForm
                  const currentIndex = unitFormList.indexOf(form.name)
                  if (currentIndex !== -1) {
                    if (currentIndex + 1 < unitFormList.length) {
                      nextUnitForm = unitFormList[currentIndex + 1]
                    } else nextUnitForm = unitFormList[0]
                  } else {
                    nextUnitForm = unitFormList[lastUnitFormIndex]
                  }
                  handleSetFormNumber(formList.indexOf(nextUnitForm ?? form.name))
                }}
              >
                <SvgCustomIcon name={'car'} color={form.type === 'units' ? 'white' : theme.palette.newColors.gray} />
              </IconButton>
            </Badge>}
          {Object.prototype.hasOwnProperty.call(formModel, 'people') &&
            <Badge
              color='primary'
              overlap='circular'
              badgeContent={peopleBadge}
            >
              <IconButton
                sx={form.type === 'people' ? { backgroundColor: theme.palette.newColors.gray } : {}}
                onClick={() => {
                  submitRef.current.requestSubmit()
                  let nextPeopleForm
                  const currentIndex = peopleFormList.indexOf(form.name)
                  if (currentIndex !== -1) {
                    if (currentIndex + 1 < peopleFormList.length) {
                      nextPeopleForm = peopleFormList[currentIndex + 1]
                    } else nextPeopleForm = peopleFormList[0]
                  } else {
                    nextPeopleForm = peopleFormList[lastPeopleFormIndex]
                  }
                  handleSetFormNumber(formList.indexOf(nextPeopleForm ?? form.name))
                }}
              >
                <SvgCustomIcon name={'person'} color={form.type === 'people' ? 'white' : theme.palette.newColors.gray} />
              </IconButton>
            </Badge>}
        </Box>
      </Box>
      <Box overflow='auto'>
        {!!Object.keys(reporterData).length &&
          <Card variant="outlined" sx={{ m: 1, pt: 1, pb: 1, pr: 2, pl: 2 }} >
            {/* <CardContent sx={{ pb: 2 }}> */}
              <Typography sx={{ color: 'text.secondary', fontSize: 13 }}>
                <Trans>Reported by</Trans>
              </Typography>
              <Typography variant='h6' component='div'>
                {`${reporterData.name} ${reporterData.surname}`}
              </Typography>
              <Typography gutterBottom component='div'>
                {reporterData.department}
              </Typography>
              <Typography sx={{ color: 'text.secondary', fontSize: 13 }}>
                <Trans>Telephone</Trans>
              </Typography>
              <Typography gutterBottom={!!reporterData.email} variant='h6' component='div'>
                {reporterData.phone}
              </Typography>
              {reporterData.email && <>
                <Typography sx={{ color: 'text.secondary', fontSize: 13 }}>
                  <Trans>email</Trans>
                </Typography>
                <Typography variant='h6' component='div'>
                  {reporterData.email}
                </Typography>
              </>}
            {/* </CardContent> */}
          </Card>
        }
        <Form
          token={token}
          isMobile={isMobile}
          submitRef={submitRef}
          formModel={memoizedFormModel}
          formList={memoizedFormList}
          form={memoizedForm}
          // unitsFormArray={{ fields: unitsMethods.fields }}
          handleCrashSubmit={handleCrashSubmit}
          handleAppend={handleAppend}
          handleSave={''}
          images={images}
          isReadOnly={isReadOnly}
        />
        <Box display='flex' flexDirection='column' gap={1} mt={2} mb={2} pl={1} pr={1}>
          {isMobile && isLoading && <CircularProgress />}
          {form.type === 'crash' && getFormCtxUserOrg() !== 2 &&
            <Box display='flex' justifyContent='center' gap={1}>
              {!isReadOnly &&
                <Button sx={{ width: '33%',background: theme.palette.newColors.pinkGradient }} variant='contained' onClick={() => openDeleteDialog()}>
                  <SvgCustomIcon name={'delete'} color={'white'}/>
                </Button>}
            </Box>}
          {form.type === 'crash' && getFormCtxUserOrg() === 2 &&
            <Box display='flex' gap={1}>
              {!isReadOnly &&
                <Button fullWidth sx={{background:theme.palette.newColors.cyanGradient}} variant='contained' onClick={() => { handleAppend('people') }}>
                  <AddIcon variant='person' />
                </Button>}
              {!isReadOnly &&
                <Button fullWidth sx={{background: theme.palette.newColors.pinkGradient }} variant='contained' onClick={() => openDeleteDialog()}>
                  <SvgCustomIcon name={'delete'} color={'white'}/>
                </Button>}
            </Box>}
          {form.type === 'road' &&
            <Box display='flex' gap={1}>
              {!isReadOnly &&
                <Button sx={{background:theme.palette.newColors.cyanGradient}} fullWidth variant='contained' onClick={() => { handleAppend('units') }}>
                  <AddIcon variant='unit' />
                </Button>}
              {!isReadOnly &&
                <Button fullWidth sx={{background: theme.palette.newColors.pinkGradient }} variant='contained' onClick={() => openDeleteDialog()}>
                  <SvgCustomIcon name={'delete'} color={'white'}/>
                </Button>}
            </Box>}
          {form.type === 'units' &&
            <>
              <Box sx={{display:'flex',flexDirection:'row',justifyContent:'space-between'}} gap={1}>
                {!isReadOnly &&
                  <Button sx={{background:theme.palette.newColors.cyanGradient,borderRadius:2,p:1}} variant='contained' onClick={() => { handleAppend('units') }}>
                    <AddIcon variant='unit' />
                  </Button>}
                {!isReadOnly &&
                    <Button sx={{background:theme.palette.newColors.cyanGradient,borderRadius:2,p:1}} variant='contained' onClick={() => { handleAppend('unitPeople', formList[form.number], append) }}>
                      <AddIcon variant='person' />
                    </Button>}
                {!isReadOnly &&
                  <Button sx={{background: theme.palette.newColors.pinkGradient,borderRadius:2,p:1 }} variant='contained' onClick={() => handleRemove('units', form)}>
                    <SvgCustomIcon name={'delete'} color={'white'}/>
                  </Button>}


              </Box>
            </>}
          {form.type === 'people' && getFormCtxUserOrg() !== 2 &&
            <Box display='flex' gap={1}>
              {!isReadOnly &&
                <Button sx={{background:theme.palette.newColors.cyanGradient}} fullWidth variant='contained' onClick={() => { handleAppend('unitPeople', formList[form.number], append) }}>
                  <AddIcon variant='person' />
                </Button>}
              {!isReadOnly &&
                <Button sx={{background: theme.palette.newColors.pinkGradient }} fullWidth variant='contained' onClick={() => handleRemove('unitPeople', form, remove)}>
                  <SvgCustomIcon name={'delete'} color={'white'}/>
                </Button>}
            </Box>}
          {form.type === 'people' && getFormCtxUserOrg() === 2 &&
            <Box display='flex' gap={1}>
              {!isReadOnly &&
                <Button sx={{background:theme.palette.newColors.cyanGradient}} fullWidth variant='contained' onClick={() => { handleAppend('people', formList[form.number], append) }} >
                  <AddIcon variant='person' />
                </Button>}
              {!isReadOnly &&
                <Button sx={{background: theme.palette.newColors.pinkGradient }} fullWidth variant='contained' onClick={() => handleRemove('people', form)}>
                  <SvgCustomIcon name={'delete'} color={'white'}/>
                </Button>}
            </Box>}
        </Box>
        <Box
          display='flex'
          mt={3}
          pr={1}
          pl={1}
          gap={1}
          mb={isMobile ? `calc(${theme.spacing(3)} + ${theme.mixins.toolbar.minHeight}px)` : 2}
        >
          {isMobile && isLoading
            ? <CircularProgress />
              : <Box sx={{ position: 'relative', width: '100%', mt: 1 }}>
                {/* Linea centrale */}
                <Box
                    sx={{
                      height: 2,
                      background: theme.palette.newColors.lightGray,
                      width: '90%',
                      marginLeft: '5%',
                      position: 'absolute',
                      top: '50%',

                      zIndex: 0,
                    }}
                />

                {/* Bottoni sopra la linea */}
                <Box
                    sx={{
                      position: 'relative',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      width: '90%',
                      marginLeft: '5%',
                      zIndex: 1,
                    }}
                >
                  <Button
                      sx={{background: theme.palette.newColors.lightGray,
                        borderRadius: '50%',
                        width: 36,
                        display:'flex',
                        justifyContent:'center',
                        alignItems:'center',
                        height: 36,
                        minWidth: 0,
                        '&:hover': {
                          background: theme.palette.newColors.lightGray,
                        },
                        p: 0,}}
                      disabled={form.number === 0}
                      onClick={() => {
                        submitRef.current.requestSubmit()
                        handleSetFormNumber('-')
                      }}
                  >
                    <SvgCustomIcon name={'arrowLeft'} size={16} color={form.number === 0 ? theme.palette.newColors.gray : theme.palette.newColors.lighGray} />
                  </Button>

                  {!isReadOnly &&
                      <Button
                          sx={{background: theme.palette.newColors.gray,
                            '&:hover':{
                              background: theme.palette.newColors.gray,
                            },
                            borderRadius: '50%',
                            width: 36,
                            height: 36,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            minWidth: 0,
                            p: 0,}}
                          disabled={(!getValues().units?.length && !getValues().people?.length)}
                          onClick={() => {
                            setValue('isFinal', true)
                            // submitRef.current.requestSubmit()
                            openSaveDialog()
                          }}
                      >
                        <SvgCustomIcon name={'save'} color={theme.palette.newColors.lightGray} />
                      </Button>}
                  <Button
                      sx={{background: theme.palette.newColors.lightGray,
                        borderRadius: '50%',
                        width: 36,
                        display:'flex',
                        justifyContent:'center',
                        alignItems:'center',
                        height: 36,
                        minWidth: 0,
                        '&:hover': {
                          background: theme.palette.newColors.lightGray,
                        },
                        p: 0,}}
                      disabled={form.number === formList.length - 1}
                      onClick={() => {
                        submitRef.current.requestSubmit()
                        handleSetFormNumber('+')
                      }}
                  >
                    <SvgCustomIcon size={16}  name={'arrowRight'} />
                  </Button>
                </Box>
              </Box>}
        </Box>
      </Box>
      <Dialog open={isSaveDialogOpen} onClose={closeSaveDialog}>
        <DialogTitle sx={{color:theme.palette.newColors.gray}}>
          <Trans>What do you want to do?</Trans>
        </DialogTitle>
        <DialogContent>
          {isNew ?
            <DialogContentText>
              <Trans>
                Save as Draft will store the crash record temporarily.
                <br />
                It can be edited later and will not appear in any database until it is saved as Final.
              </Trans>
              <br />
              <br />
              <Trans>
                Save as Final will store the crash record in your institution’s database.
                <br />
                Final crashes are ready for official validation.
              </Trans>
            </DialogContentText>
            : <DialogContentText>
              <Trans>
                Save as Final will modify the crash record in your institution’s database.
                <br />
                Final crashes are ready for official validation.
              </Trans>
            </DialogContentText>
          }
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' color='error' onClick={closeSaveDialog}>
            <Trans>Cancel</Trans>
          </Button>
          {isNew &&
            <Button
            variant='outlined'
            color='success'
            onClick={() => {
              setValue('isDraft', true)
              setValue('isFinal', true)
              submitRef.current.requestSubmit()
              closeSaveDialog()
            }}>
            <Trans>Save as draft</Trans>
          </Button>}
          {isOnline && <Button
            variant='outlined'
            sx={{color: theme.palette.newColors.gray,fontWeight:600,border:``}}
            onClick={() => submitRef.current.requestSubmit()}
            autoFocus
          >
            <Trans>Save as final</Trans>
          </Button>}
        </DialogActions>
      </Dialog>
      <Dialog open={isDeleteDialogOpen} onClose={closeDeleteDialog}>
        <DialogTitle>
          <Trans>Are you sure?</Trans>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Trans>
              The crash will be permanently deleted!
            </Trans>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant='outlined'
            color='success'
            onClick={closeDeleteDialog}
            autoFocus
          >
            <Trans>Cancel</Trans>
          </Button>
          <Button
            variant='outlined'
            color='error'
            onClick={() => cancelCrash(crashId)}
          >
            <Trans>Yes, delete</Trans>
          </Button>
        </DialogActions>
      </Dialog>
    </StyledDrawer>
  )
}
